import React, { FC } from "react";
import * as _ from "lodash";

import { GenericEventView, IdaQnAChildEventView, testIds, useEvent, EventContext } from "@events";
import { Col, Row, Typography } from "@ctra/components";

const { Text } = Typography;

/**
 * Custom Event View component
 * @constructor
 */
export const CustomEventView: FC<{ open?: boolean }> = (props) => {
  const {
    getDescription,
    event: { children: childEvents }
  } = useEvent();

  return (
    <GenericEventView {...props}>
      <Row data-testid={testIds.entity.entry.description} gutter={[0, 8]}>
        {getDescription() && (
          <Col span={24}>
            <Text>{getDescription()}</Text>
          </Col>
        )}
        {!!childEvents.length &&
          _.map(childEvents, ({ id }) => (
            <Col key={id} span={24}>
              <EventContext.Provider eventID={id}>
                <IdaQnAChildEventView />
              </EventContext.Provider>
            </Col>
          ))}
      </Row>
    </GenericEventView>
  );
};
